import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { cleanObj } from '../../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { AccountAddress } from '../../../../../../shared/types/modules/account';
import { AccountAddressProps } from './props';
import { asyncGetCities } from '../../../../../../services/location.service';
import { formatParams } from '../../../../../../shared/utils/params';
import { asyncGetParams } from '../../../../../../services/param.service';

export const useAccountAddress = ({
    data,
    onChangeData,
    onChangeFormik,
}: AccountAddressProps) => {
    const [cities, setCities] = useState<ISelect[]>([]);
    const [types1, setTypes1] = useState<ISelect[]>([]);
    const letters: ISelect[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        .split('')
        .map((letter) => ({ id: letter, name: letter }));
    const onSubmit = (data: AccountAddress) => {
        if (onChangeData)
            onChangeData(cleanObj(data) || ({} as AccountAddress));
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        const address = [];
        const values = formik.values;

        if (Boolean(values.city)) {
            const city = cities.find((c) => c.id === values.city);
            address.push(city?.name + ',' || '');
        }
        if (Boolean(values.type1)) {
            const type1 = types1.find((t) => t.id === values.type1);
            address.push(type1?.name || '');
        }
        if (Boolean(values.type2)) address.push(values.type2);
        if (Boolean(values.number1)) address.push(values.number1);
        if (Boolean(values.letter1)) address.push(values.letter1);
        if (Boolean(values.letter2)) address.push(values.letter2);
        if (Boolean(values.quadrant1)) address.push(values.quadrant1);
        if (Boolean(values.number2)) address.push(values.number2);
        if (Boolean(values.letter3)) address.push(values.letter3);
        if (Boolean(values.letter4)) address.push(values.letter4);
        if (Boolean(values.quadrant2)) address.push(values.quadrant2);
        if (Boolean(values.number3)) address.push(values.number3);
        if (Boolean(values.quadrant3)) address.push(values.quadrant3);
        if (Boolean(values.complement)) {
            const last = address.pop();
            if (last) address.push(last + ',');
            address.push(values.complement);
        }

        formik.setFieldValue('address', address.join(' '));
    }, [formik.values]);

    useEffect(() => {
        formik?.setFieldValue('city', data?.city || '');
        formik?.setFieldValue('type1', (data?.type1 as ISelect)?.id || '');
        formik?.setFieldValue('type2', data?.type2 || '');
        formik?.setFieldValue('number1', data?.number1 || '');
        formik?.setFieldValue('letter1', data?.letter1 || '');
        formik?.setFieldValue('letter2', data?.letter2 || '');
        formik?.setFieldValue('quadrant1', data?.quadrant1 || '');
        formik?.setFieldValue('number2', data?.number2 || '');
        formik?.setFieldValue('letter3', data?.letter3 || '');
        formik?.setFieldValue('letter4', data?.letter4 || '');
        formik?.setFieldValue('quadrant2', data?.quadrant2 || '');
        formik?.setFieldValue('number3', data?.number3 || '');
        formik?.setFieldValue('quadrant3', data?.quadrant3 || '');
        formik?.setFieldValue('complement', data?.complement || '');
        formik?.setFieldValue('address', data?.address || '');
    }, [data]);

    useEffect(() => {
        asyncGetCities().then((cities) => setCities(formatParams(cities)));
        asyncGetParams(ParamEnum.ADDRESS_TYPE).then((params) =>
            setTypes1(formatParams(params))
        );
    }, []);

    return {
        formik,
        cities,
        types1,
        letters,
    };
};
